import { DivNumberInput } from "@/components/DivInput/DivNumberInput"
import { LineRecord, NodeState, SetOperation } from "@/components/FlowSheetEditor/services/modal"
import { ManualObject } from "@/services/project/modal"
import { AppDispatch } from "@/store"
import { useMemo } from "react"
import { useDispatch } from "react-redux"
import { toDefaultUnitVal, toUnitVal, toUnitValStrWithFormat } from "./utils"
import {isObject, isNumber} from 'lodash-es'
import { addManualInputThunk, deleteManualInputThunk } from "@/store/flowsheet/actions"
import styles from './styles.module.less'
import { useSelector } from "react-redux"
import { getActiveUnitSet } from "@/store/project/selector"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"

interface ManualInputProps {
  data: number | ManualObject
  attrKey: string
  unit: NodeState | LineRecord | SetOperation
  dimCode?: string
  style?: any
}

export const ManualInput = (props: ManualInputProps) => {
  const {data, attrKey, unit, dimCode, style} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const unitSet = useSelector(getActiveUnitSet)
  const dispatch = useDispatch<AppDispatch>()

  const varUnitData = useMemo(() => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [unitSet, dimCode])

  const onChange = async (value: number) => {
    dispatch(addManualInputThunk({
      data: {dvars: [{unitId: unit.id, attribute: attrKey, value: toDefaultUnitVal(value, varUnitData?.unit)}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  const onDelete = async () => {
    dispatch(deleteManualInputThunk({
      data: {dvars: [{unitId: unit.id, attribute: attrKey, value: undefined}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  if (isNumber(data)) {
    return <span>{toUnitValStrWithFormat(data as number, varUnitData)}</span>
  }

  if (!isObject(data)) {
    return <DivNumberInput
      unitEntity={varUnitData}
      dimCode={dimCode}
      value={toUnitVal(data as number, varUnitData?.unit)}
      style={style}
      onChange={onChange}/>
  }

  return <DivNumberInput
    unitEntity={varUnitData}
    className={styles.manualInputRow}
    dimCode={dimCode}
    removeAble={true}
    value={toUnitVal((data as ManualObject).val, varUnitData?.unit)}
    onChange={onChange}
    onDelete={onDelete}
    style={style}
  />
}